import React, { Component } from 'react';
import { array, bool, func, number, string, object } from 'prop-types';
import apiClient from 'ps-components/lib/apiClient';
import { Segmented } from 'ps-design';
import Search from 'ps-components/Search/Search';
import { numberWithCommas } from 'ps-components/lib/formatters';
import fileDownload from 'js-file-download';
import './SubHeaderSearch.scss';
import { ActionIcon, Group, Select, Tooltip } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';

class SubHeaderSearch extends Component {
  static propTypes = {
    clearSearch: func,
    isSelected: bool,
    placeholderText: string,
    searchId: string,
    searchByText: func,
    searchText: string,
    selectedItems: array,
    setSearchText: func,
    toggleSelected: func,
    totalCount: number,
    showSelectAllText: bool,
    dataCuts: array,
    session: object,
    survey: object,
    isDataCutSlideout: bool,
    selectedElementGroup: string,
    setSelectedElementGroup: func
  };

  static defaultProps = {
    showSelectAllText: false
  };

  state = { loading: false };

  componentDidMount() {
    const { searchId, searchByText } = this.props;
    const searchBox = document.getElementById(searchId);
    if (searchBox) searchBox.addEventListener('keydown', e => searchByText(e));
  }

  UNSAFE_componentWillUnmount() {
    const { searchByText, searchId } = this.props;
    const searchBox = document.getElementById(searchId);
    if (searchBox) searchBox.removeEventListener('keydown', e => searchByText(e));
  }

  componentDidUpdate(prevProps) {
    const { selectedItems } = this.props;
    if (prevProps.selectedItems.length !== selectedItems.length) {
      this.setState({ loading: false });
    }
  }

  setSearchText = event => {
    const { setSearchText } = this.props;

    event.persist();
    const value = event.target.value;
    setSearchText(value);
  };

  handleClick = () => {
    this.props.selectAllFilteredJobs();
    this.setState({
      loading: !this.state.loading
    });
  };

  handleDownloadDataCuts = async (dataCuts, session, survey, selectedElementGroup, displayIn) => {
    try {
      const { csrf_token, csrf_timestamp } = session
      const surveyJob = {
        surveyShortName: survey.survey_short_name_default || survey.pub_survey_short_name_default,
        surveyCode: survey.survey_code_default,
        jobTitle: survey.job_title_default,
        jobCode: survey.job_code_default,
        jobDescription: survey.job_description_default,
        currency: survey.currency_default || survey.currency,
        monetaryDisplay: displayIn
      }
      const response = await apiClient.apiPost('/api/util/report-print/dataCutsToExcel', { surveyJob, dataCuts, selectedElementGroup, csrf_timestamp, csrf_token }, { responseType: 'arraybuffer' });
      fileDownload(response.data, `data_cuts.xlsx`);
    } catch (error) {
      console.error('Error downloading data cuts to excel: ', error)
    }
  }

  render() {
    const {
      clearSearch,
      isSelected,
      placeholderText,
      searchId,
      searchText,
      selectedItems,
      toggleSelected,
      totalCount,
      showSelectAllText,
      showClearLink,
      dataCuts,
      session,
      survey,
      displayIn,
      selectedElementGroup,
      setSelectedElementGroup,
      isDataCutSlideout
    } = this.props;
    const { loading } = this.state;

    return (
      <div className="subheader__search">
        <div className="subheader__search-row">
          <Segmented
            className="pxl-segmented-secondary"
            onChange={toggleSelected}
            options={[
              {
                text: `All (${(totalCount && numberWithCommas(totalCount)) || 0})`,
                value: isSelected
              },
              { text: `Selected (${selectedItems.length})`, value: !isSelected }
            ]}
            value={true}
          />
          { isDataCutSlideout &&
          <Group align='flex-end'>
            <Select
              value={selectedElementGroup}
              data={[
                { label: 'Base Salary', value: 'baseSalary'},
                { label: 'Total Cash', value: 'totalCash' },
                { label: 'Total Target Cash', value: 'totalTargetCash' },
                { label: 'Total Direct', value: 'totalDirect' },
                { label: 'Total Guaranteed Pay', value: 'totalGuaranteedPay' }
              ]}
              onChange={setSelectedElementGroup}
              size='lg'
              maxDropdownHeight={350}
            />
          <Tooltip label='Download to Excel'>
            <ActionIcon size='xl' variant='transparent' onClick={() => this.handleDownloadDataCuts(dataCuts, session, survey, selectedElementGroup, displayIn)}>
              <IconDownload style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Tooltip>
          </Group> }
          {loading && showSelectAllText && (
            <div>
              <i className="icon-animate-spin icon-spin" />
              {`Processing All ${numberWithCommas(totalCount)}`}
            </div>
          )}
          {showSelectAllText && !loading && isSelected && (
            <a onClick={this.handleClick}>{`Select All ${numberWithCommas(totalCount)}`}</a>
          )}
          {showClearLink && <a onClick={this.handleClick}>{'Clear All Selections'}</a>}
        </div>
        <div className="subheader__search-row">
          <Search
            className="search__input"
            id={searchId}
            onChange={this.setSearchText}
            onClick={clearSearch}
            placeholder={placeholderText}
            value={searchText}
          />
        </div>
      </div>
    );
  }
}

export default SubHeaderSearch;
